import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCachedCategories } from './useCachedData';

export const useLocalizedCategory = (branchId: string, categoryId: string | undefined | null) => {
    const { i18n } = useTranslation();
    const { categories } = useCachedCategories({ branchId });

    const category = useMemo(() => {
        if (!categoryId) return null;
        return categories.find(cat => cat.id === categoryId);
    }, [categories, categoryId]);

    const localizedName = useMemo(() => {
        if (!category) return '';
        
        if (i18n.language === 'ar' && category.ar) {
            // category.ar can be a string (stringified JSON) or an object (already parsed JSONB)
            let arData: any = category.ar;
            
            if (typeof category.ar === 'string') {
                try {
                    arData = JSON.parse(category.ar);
                } catch (e) {
                    // If parsing fails, treat it as a raw string if it's not JSON
                    if (category.ar.trim() !== '') return category.ar;
                    return category.name || '';
                }
            }

            if (arData && typeof arData === 'object' && arData.name) {
                return arData.name;
            }
        }
        if (category.name && typeof category.name === 'string' && category.name.trim() !== '') {
            return category.name;
        }
        return '';
    }, [category, i18n.language]);

    return { category, localizedName };
};
